import React from "react";
import "./About.scss";
import images from "../../Data/images";
import { FaArrowsAltH } from "react-icons/fa";

const About = () => {
  return (
    <div className="about">
      <div className="maincontainer">
        <div className="left-content">
          <div className="title">
            <span>About Argus Security International Inc.</span>
          </div>
          <div className="subtitle">
            <span>Professional Security Services Across Ontario</span>
          </div>

          <div className="para">
            <p>
              Argus Security International provides professional security
              solutions designed to protect people, property, and assets.
            </p>

            <p>
              Our team delivers reliable protection for commercial properties,
              residential communities, construction projects, retail
              environments, and private clients.
            </p>

            <p>
              By combining trained security personnel, modern technology, and
              strong operational standards, Argus provides dependable security
              services that clients can trust.
            </p>
          </div>
        </div>
        <div className="right-image">
          <img src={images.s4} alt="image" />
        </div>
      </div>
      <div className="othercontainer">
        <div className="aboutgrid">
          <div className="image">
            <img src={images.ab1} alt="photo" />
          </div>
          <div className="content">
            <span>Real-time Monitoring</span>
          </div>
        </div>
        <div className="aboutgrid">
          <div className="image">
            <img src={images.ab2} alt="photo" />
          </div>
          <div className="content">
            <span>Threat Detection</span>
          </div>
        </div>
        <div className="aboutgrid">
          <div className="image">
            <img src={images.ab3} alt="photo" />
          </div>
          <div className="content">
            <span>Incident Response</span>
          </div>
        </div>
        <div className="aboutgrid">
          <div className="image">
            <img src={images.ab4} alt="photo" />
          </div>
          <div className="content">
            <span>Proactive Security</span>
          </div>
        </div>
      </div>
      <div className="newcontainer">
        <div className="heading">
          <span>Our Security Services</span>
        </div>

        <div className="para">
          <span>
            Argus Security International offers a wide range of professional
            security solutions designed to protect people, property, and assets.
          </span>
        </div>

        <div className="links">
          <a href="service">Uniformed Security Guards</a>
          <a href="service">Mobile Patrol Services</a>
          <a href="service">Construction Site Security</a>
          <a href="service">Parking Enforcement</a>
          <a href="service">Concierge Security</a>
          <a href="service">Gatehouse Security</a>
          <a href="service">CCTV & Access Control</a>
          <a href="service">Fire Watch Security</a>
        </div>

        <div className="atag">
          <a href="service">VIEW ALL SERVICES</a>
        </div>
      </div>

      <div className="newcontainer">
        <div className="heading">
          <span>Technology-Driven Protection</span>
        </div>

        <div className="para">
          <span>
            Argus integrates advanced security technology with professional
            personnel to improve visibility, reporting, and response.
          </span>
        </div>

        <div className="links">
          <a>Digital Incident Reporting</a>
          <a>CCTV Surveillance Systems</a>
          <a>Access Control Technology</a>
          <a>Patrol Verification Systems</a>
          <a>Remote Monitoring</a>
        </div>
      </div>
      <div className="newcontainer">
        <div className="heading">
          <span>Industries We Protect</span>
        </div>

        <div className="links">
          <a>Commercial Office Buildings</a>
          <a>Residential & Condominium Communities</a>
          <a>Construction Sites</a>
          <a>Retail Businesses</a>
          <a>Industrial Facilities</a>
          <a>Logistics & Truck Yards</a>
          <a>Events & Private Functions</a>
        </div>
      </div>
      <div className="service-container">
        <div className="left-content">
          <div className="title">
            <span>SERVICE COVERAGE</span>
          </div>
          <div className="subtitle">
            <span>
              Nationwide Service <br />
              Coverage Available
            </span>
          </div>
          <div className="icon">
            <a href="">
              <FaArrowsAltH />
            </a>
          </div>
          <div className="image">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2883.970366561617!2d-79.653288!3d43.7111649!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b3c0634378905%3A0x1637666d9090318a!2sArgus%20Security%20Intl!5e0!3m2!1sen!2sin!4v1743007941539!5m2!1sen!2sin"
              width="600"
              height="250"
              style={{ border: 0 }}
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
        <div className="right-content">
          <div className="heading">
            <span>Corporate Headquarters In</span>
          </div>
          <div className="sub-heading">
            <span>Mississauga, ON</span>
          </div>
          <div className="context">
            <p>
              2985 Drew Rd. Suite 216 Mississauga, <br /> ON L4T 0A4, Canada
            </p>
          </div>
          <div className="heading">
            <span>With Offices located</span>
          </div>
          <div className="sub-heading">
            <span>In Mississauga & Barrie Canada</span>
          </div>
          <div className="para">
            <p>
              Headquartered in Mississauga, we proudly provide <br /> security
              services across Canada. No matter where <br /> you are, our
              trusted team is ready to serve and protect.
            </p>
          </div>
          <div className="button">
            <a href="locations">FIND A LOCATION</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
